export default "__VITE_ASSET__00e6cd45__"